import { render, staticRenderFns } from "./LayoutProvider.vue?vue&type=template&id=64888eb4&"
import script from "./LayoutProvider.vue?vue&type=script&lang=js&"
export * from "./LayoutProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports